export const namespaced = true;

export const state = {
  sidebarItems: [
    {
      id: 1,
      name: 'home',
      forwardPath: 'home',
      title: 'ID管理',
      feather: 'home',
      imagePath: 'Icon grid home.png',
      srOnly: true,
    },
    {
      id: 2,
      name: 'billing',
      forwardPath: 'billing',
      title: '請求',
      feather: 'billing',
      imagePath: 'Icon billing home.png',
      srOnly: false,
    },
    {
      id: 3,
      name: 'lesson',
      forwardPath: 'home',
      title: '授業モード',
      feather: 'lesson',
      imagePath: 'Icon awesome-chalkboard.png',
      srOnly: false,
    },
    {
      id: 4,
      name: 'advance',
      forwardPath: 'advance-student',
      title: '進級管理',
      feather: 'advance',
      imagePath: 'Icon advance.png',
      srOnly: false,
    },
    {
      id: 5,
      name: 'student',
      forwardPath: 'student',
      title: '生徒管理',
      feather: 'student',
      imagePath: 'Icon awesome-list-ul.png',
      srOnly: false,
    },
    {
      id: 6,
      name: 'preparation',
      forwardPath: 'test-preparation-print',
      title: 'テスト対策プリント',
      feather: 'preparation',
      imagePath: 'Icon ionic-md-paper.png',
      srOnly: false,
    },
    {
      id: 7,
      name: 'notice',
      forwardPath: 'notification',
      title: 'お知らせ',
      feather: 'notice',
      imagePath: 'Icon material-notifications-active_bk.png',
      srOnly: false,
    },
    {
      id: 8,
      name: 'teacher-setting',
      forwardPath: 'teacher-profile-setting',
      title: '設定',
      feather: 'setting',
      imagePath: 'Icon ionic-md-settings.png',
      srOnly: false,
    },
    {
      id: 9,
      name: 'contact',
      forwardPath: 'contact_us',
      title: 'お問い合わせ',
      feather: 'contact',
      imagePath: 'Icon feather-mail.png',
      srOnly: false,
    },
    {
      id: 10,
      name: 'teacher-notice',
      forwardPath: 'notification',
      title: 'お知らせ',
      feather: 'notice',
      imagePath: 'Icon material-notifications-active_bk.png',
      srOnly: false,
    },
  ],
};

export const getters = {
  getSidebarItemByName: (state) => (name) => {
    return state.sidebarItems.find((item) => item.name === name);
  },
};
